export enum PurchaseRequestMilestoneType {
    Ready = "ready",
    Ordered = "ordered",
    Received = "received",
    Canceled = "canceled",
}